<!-- 库存盘点计划核对 -->
<template>
    <div class='page_content'>
        <div class="page_content_top">
            <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo" @openFormDesign="openFormDesign"></v-button>
            <div class="page_content_top_line">
                <el-form :model="ruleForm" :inline="true" ref="ruleForm" class="demo-ruleForm">
                    <el-form-item label="盘点单号">
                        <el-input clearable v-model="getData.ipmId" @keyup.enter.native="openSearch('ipmId')">
                            <el-button @click="openSearch('ipmId')" slot="append" icon="el-icon-search"></el-button>
                        </el-input>
                        <input v-show="false" type="text">
                    </el-form-item>
                    <el-form-item label="通用名称">
                        <el-input clearable v-model="getData.bgmName" @input="filterTableData('bgmName')" @clear="filterTableData('bgmName')" placeholder="输入通用名称过滤数据">

                        </el-input>

                    </el-form-item>
                    <el-form-item label="助记码">
                        <el-input clearable v-model="getData.mne"  @input="filterTableData('mne')" @clear="filterTableData('mne')" placeholder="输入助记码">
                        </el-input>
                    </el-form-item>
                    <el-form-item label="货架编号">
                        <el-input clearable v-model="getData.shelfCode" @input="filterTableData('shelfCode')" @clear="filterTableData('shelfCode')" placeholder="输入助记码">
                        </el-input>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="page_content_center">
            <div :style="`width:${tableWidth}px`">
                <el-table class="left table" ref="singleTable" size="mini" stripe :height="tableHeight" :key="$store.state.tableNum" border :data="paginatedData" highlight-current-row @row-click="rowClick"
                      @keyup.native="handleTableKeyDown" tabindex="0" :style="`width:${tableWidth}px`">
                <el-table-column label="选择操作" width="80">
                    <template slot-scope="scope">
                        <el-radio v-model="selectedDataIndex" :label="scope.$index" border size="mini">
                            <i class="el-icon-thumb"></i>
                        </el-radio>
                    </template>
                </el-table-column>
                <template v-for="(tableValye, tableKey) in returnData.name">
                    <el-table-column align="center" v-if="tableValye.isShow == 1" show-overflow-tooltip :min-width="tableValye.fieldWeight" :key="tableKey" :prop="tableValye.entityField" :label="tableValye.showField">
                        <template slot-scope="scope">
                            <span v-if="tableValye.fieldType == 'date'">
                                <span v-if="scope.row[tableValye.entityField]">
                                    {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                                </span>
                            </span>
                            <span v-else-if="tableValye.isRift == 1">
                                <a @click="toDetail(scope.row[tableValye.riftField])">{{ scope.row[tableValye.entityField] }}</a>
                            </span>
                            <span v-else-if="tableValye.entityField == 'createTime'">
                                <span v-if="scope.row[tableValye.entityField]">
                                    {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                                </span>
                            </span>
                            <span v-else-if="tableValye.entityField == 'ipmState'">
                                <el-tag size="mini">{{ $common.getIsGsp(tableValye.formatterContent, scope.row.ipmState) }}</el-tag>
                            </span>
                            <span v-else>
                                {{ scope.row[tableValye.entityField] }}
                            </span>
                        </template>
                    </el-table-column>
                </template>
            </el-table>

            <!-- 分页组件 -->
            <div class="pagination-wrapper" v-if="filteredData && filteredData.length > pageSize">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
                               layout="total, sizes, prev, pager, next, jumper" :total="totalRows">
                </el-pagination>
            </div>
            </div>

            <el-table :key="index" class="right table" :data="data" size="mini" stripe :height="tableHeight" border>
                <el-table-column label="详情" align="center">
                    <template>
                        <el-form :model="ruleForm" ref="ruleForm" :show-message="false" label-width="100px" class="demo-ruleForm">
                            <el-form-item label="通用名称">
                                <el-input disabled v-model="ruleForm.bgmName" clearable></el-input>
                            </el-form-item>
                            <el-form-item label="规格">
                                <el-input disabled v-model="ruleForm.spec" clearable></el-input>
                            </el-form-item>
                            <el-form-item label="生产厂家">
                                <el-input disabled v-model="ruleForm.manufacturer" clearable></el-input>
                            </el-form-item>
                            <el-form-item label="批号">
                                <el-input disabled v-model="ruleForm.batchno" clearable></el-input>
                            </el-form-item>
                            <el-form-item label="生产日期">
                                <el-date-picker class="dete" disabled size="mini" v-model="ruleForm.prodate" format="yyyy年MM月dd日" value-format="timestamp" type="date" placeholder="选择日期"></el-date-picker>
                            </el-form-item>
                            <el-form-item label="有效期至">
                                <el-date-picker class="dete" disabled size="mini" v-model="ruleForm.expidate" format="yyyy年MM月dd日" value-format="timestamp" type="date" placeholder="选择日期"></el-date-picker>
                            </el-form-item>
                            <el-form-item label="库存数量">
                                <el-input disabled v-model="ruleForm.ipdTnumber" clearable></el-input>
                            </el-form-item>
                            <el-form-item label="实盘数量" prop="ipdAinumber" :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                                <el-input ref="ipdAinumber" @input="input(ruleForm.ipdAinumber)" v-model.number="ruleForm.ipdAinumber" clearable></el-input>
                            </el-form-item>
                            <el-form-item label="损溢数量">
                                <el-input disabled v-model="ruleForm.ipdOlnumber" clearable></el-input>
                            </el-form-item>
                            <el-form-item label="货架编号">
                                <el-input disabled v-model="ruleForm.shelfCode" clearable></el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
                            </el-form-item>
                        </el-form>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-dialog title="盘点计划" v-if="DialogVisible" :visible.sync="DialogVisible" width="80%">
            <searchShomes :obj="obj" :fromNamelist="fromNamelist" @TranData="changeInputModel"></searchShomes>
        </el-dialog>
        <customDesign ref="customDesign"></customDesign>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import stockLnventory from "./stockLnventory";
import NP from 'number-precision'
import searchShomes from "./searchShomes.vue";
export default {
    //import引入的组件需要注入到对象中才能使用
    components: {
        searchShomes
    },
    data() {
        //这里存放数据
        return {
            tableHeight: 0,
            buttonList: [],//按钮权限
            tableWidth: 0,
            getData: {
                ipmId: "",
                mne: "",
                bgmName: "",
                shelfCode:"",
                page: 1,
                rows: 10
            },
            // 前端分页相关
            currentPage: 1,
            pageSize: 20, // 每页显示数量
            allData: [], // 存储所有数据
            filteredData: [], // 存储过滤后的数据
            serchlist: [],//检索
            data: [
                {
                    name: "详情"
                }
            ],
            returnData: {
                list: [],
                name: [],
                obj: {
                    total: 0
                }
            },
            //选中的数据
            currentRow: {},
            selectedDataIndex: 0,//选中的index
            ruleForm: {
                batchno: "",
                bgiPerholder: "",
                bgiProrangeName: "",
                bgiStocondition: "",
                bgmCode: "",
                bgmId: 0,
                bgmName: "",
                bgpUnitmeasurement: "",
                bgsId: 0,
                coId: 0,
                coName: "",
                createTime: 0,
                creater: 0,
                expidate: 0,
                ipdAinumber: 0,
                ipdCheckerid: 0,
                ipdCheckername: "",
                ipdChecktime: "",
                ipdId: 0,
                ipdInverid: 0,
                ipdInvername: "",
                ipdInvtime: "",
                ipdOlnumber: 0,
                ipdRemark: "",
                ipdState: 0,
                ipdTnumber: 0,
                ipmId: "",
                manufacturer: "",
                ormId: 0,
                placeorigin: "",
                prodate: 0,
                rowno: 0,
                spec: "",
                stId: 0,
                stName: "",
                sterBatchno: "",
                updateTime: 0,
                shelfCode:"",
            },
            DialogVisible: false,
            fromNamelist: [],
            pageShowData: {},
            obj: {
                ipmId: "",
            },
            index: 0,
            ipmId: "",
        };
    },
    //监听属性 类似于data概念
    computed: {
        // 总行数 - 使用过滤后的数据
        totalRows() {
            return this.filteredData.length;
        },

        // 分页数据 - 使用过滤后的数据
        paginatedData() {
            if (!this.filteredData || this.filteredData.length === 0) {
                return [];
            }

            const start = (this.currentPage - 1) * this.pageSize;
            const end = start + this.pageSize;
            return this.filteredData.slice(start, end);
        }
    },
    //监控data中的数据变化
    watch: {
    },
    //方法集合
    methods: {
        // 处理表格键盘事件
        handleTableKeyDown(event) {
            // 如果没有数据，直接返回
            if (!this.paginatedData || this.paginatedData.length === 0) {
                return;
            }

            if (event.key === "ArrowUp" || event.key === "ArrowDown") {
                event.preventDefault();
                event.stopPropagation();

                let newIndex = this.selectedDataIndex;
                if (event.key === "ArrowUp") {
                    if (newIndex > 0) {
                        newIndex = newIndex - 1;
                    } else {
                        // 如果是第一行，跳转到上一页的最后一行
                        if (this.currentPage > 1) {
                            this.currentPage--;
                            newIndex = this.paginatedData.length - 1;
                        } else {
                            newIndex = this.paginatedData.length - 1;
                        }
                    }
                } else if (event.key === "ArrowDown") {
                    if (newIndex < this.paginatedData.length - 1) {
                        newIndex = newIndex + 1;
                    } else {
                        // 如果是最后一行，跳转到下一页的第一行
                        if (this.currentPage < Math.ceil(this.totalRows / this.pageSize)) {
                            this.currentPage++;
                            newIndex = 0;
                        } else {
                            newIndex = 0;
                        }
                    }
                }

                this.selectedDataIndex = newIndex;

                this.$nextTick(() => {
                    const selectedRow = this.paginatedData[newIndex];
                    if (selectedRow) {
                        this.$refs.singleTable.setCurrentRow(selectedRow);
                        for (const key in this.ruleForm) {
                            this.ruleForm[key] = selectedRow[key];
                        }
                        this.index = this.index === 0 ? 1 : 0;
                    }
                });
            }
        },

        // 分页大小变化
        handleSizeChange(val) {
            this.pageSize = val;
            this.currentPage = 1;
            this.selectedDataIndex = 0;

            this.$nextTick(() => {
                if (this.paginatedData[0]) {
                    this.$refs.singleTable.setCurrentRow(this.paginatedData[0]);
                    for (const key in this.ruleForm) {
                        this.ruleForm[key] = this.paginatedData[0][key];
                    }
                    this.index = this.index === 0 ? 1 : 0;
                }
            });
        },

        // 当前页变化
        handleCurrentChange(val) {
            this.currentPage = val;
            this.selectedDataIndex = 0;

            this.$nextTick(() => {
                if (this.paginatedData[0]) {
                    this.$refs.singleTable.setCurrentRow(this.paginatedData[0]);
                    for (const key in this.ruleForm) {
                        this.ruleForm[key] = this.paginatedData[0][key];
                    }
                    this.index = this.index === 0 ? 1 : 0;
                }
            });
        },
        actionSet(buttonValue) {
            switch (buttonValue.actionType) {
                case 3:
                    this.invplanfinishInvPlan()
                    break;
                default:
                    break;
            }
        },
        openFormDesign() {
            let pathInfo = parent.getMenuInfo(this.$route.path)
            this.$refs['customDesign'].openBox(pathInfo.jurId, this.pageShowData, pathInfo.jurName)
        },
        invplanfinishInvPlan() {
            this.$confirm("确定要提交核对吗？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(async () => {
                    var delData = {
                        ids: [this.ipmId],
                    };
                    let responseData = await this.$http.invplanfinishInvPlan(delData);
                    if (responseData.status == 200) {
                        this.$message({
                            type: "success",
                            message: "操作成功!",
                        });
                        this.returnData.list = []
                        this.filteredData=[]
                        this.getData.ipmId = ""
                        for (const key in this.ruleForm) {
                            this.ruleForm[key] = ""
                        }
                        this.index = this.index == 0 ? 1 : 0
                    } else {
                        this.$message({
                            message: responseData.message,
                            type: "error",
                        });
                    }
                })
                .catch(() => { });
        },
        input(num) {
            this.ruleForm.ipdOlnumber = Number(this.$common.getDecimalInfo(3, NP.minus(num, this.ruleForm.ipdTnumber)))
            this.index = this.index == 0 ? 1 : 0
            this.$nextTick(() => {
                this.$refs.ipdAinumber.focus()
            })
            console.log(this.ruleForm);
        },
        rowClick(row) {
            console.log(row.ipdId);

            // 在当前页数据中查找索引
            const pageIndex = this.paginatedData.findIndex(item => item.ipdId === row.ipdId);
            if (pageIndex !== -1) {
                this.selectedDataIndex = pageIndex;
            }

            // 更新表单数据
            for (const key in this.ruleForm) {
                this.ruleForm[key] = row[key]
            }
            this.index = this.index == 0 ? 1 : 0
            console.log(this.ruleForm);
        },
        getHeight() {
            this.tableWidth = document.documentElement.querySelector(".page_content_center").clientWidth - 300
        },
        openSearch(type) {
            this.obj[type] = this.getData[type]
            this.DialogVisible = true
        },
        // 过滤表格数据
        filterTableData(type) {
            const filterText = this.getData[type] ? this.getData[type].toLowerCase() : '';
            if (!filterText) {
                // 如果没有过滤条件，显示所有数据
                this.filteredData = [...this.allData];
            } else {
                // 根据通用名称过滤数据
                this.filteredData = this.allData.filter(item => {
                    return item[type] && item[type].toLowerCase().includes(filterText);
                });
            }

            // 重置分页到第一页
            this.currentPage = 1;
            this.selectedDataIndex = 0;

            // 更新表单数据为第一行数据
            this.$nextTick(() => {
                if (this.paginatedData[0]) {
                    this.$refs.singleTable.setCurrentRow(this.paginatedData[0]);
                    for (const key in this.ruleForm) {
                        this.ruleForm[key] = this.paginatedData[0][key];
                    }
                    this.index = this.index === 0 ? 1 : 0;
                } else {
                    // 如果没有过滤结果，清空表单
                    for (const key in this.ruleForm) {
                        if (typeof this.ruleForm[key] === 'string') {
                            this.ruleForm[key] = '';
                        } else if (typeof this.ruleForm[key] === 'number') {
                            this.ruleForm[key] = 0;
                        }
                    }
                }
            });
        },
        changeInputModel(val) {
            if (val != "" && val != undefined) {
                this.DialogVisible = false;
                this.ipmId = val.ipmId
                this.getData.ipmId = val.ipmId

                if (val.invplanDetailInfos && val.invplanDetailInfos.length > 0) {
                    // 存储所有数据
                    this.allData = val.invplanDetailInfos;
                    this.returnData.list = val.invplanDetailInfos; // 保持原有逻辑兼容性

                    // 初始化过滤数据（显示所有数据）
                    this.filteredData = [...this.allData];

                    // 重置分页到第一页
                    this.currentPage = 1;
                    this.selectedDataIndex = 0;

                    this.$nextTick(() => {
                        if (this.paginatedData[0]) {
                            this.$refs.singleTable.setCurrentRow(this.paginatedData[0]);
                            for (const key in this.ruleForm) {
                                this.ruleForm[key] = this.paginatedData[0][key]
                            }
                            this.index = this.index == 0 ? 1 : 0
                        }
                        console.log(this.ruleForm);
                    });
                }
            }

            // 设置表格可以获得焦点，以便接收键盘事件
            this.$nextTick(() => {
                if (this.$refs.singleTable && this.$refs.singleTable.$el) {
                    this.$refs.singleTable.$el.focus();
                }
            });
        },
        async submitForm() {
            if (this.returnData.list == 0) {
                this.$message.error("请选择数据")
                return
            }
            const resData = await this.$http.setStockLnventoryPlan(this.ruleForm)
            if (resData.status == 200) {
                this.$message.success(resData.message)
                var ruleForm = JSON.parse(JSON.stringify(this.ruleForm))
                // 通过 ipdId 定位数据，同步更新列表、总数据及过滤数据，保证表格刷新
                var listIndex = this.returnData.list.findIndex(item => item.ipdId === this.ruleForm.ipdId)
                var allIndex = this.allData.findIndex(item => item.ipdId === this.ruleForm.ipdId)
                var filterIndex = this.filteredData.findIndex(item => item.ipdId === this.ruleForm.ipdId)
                if (listIndex !== -1) {
                    this.$set(this.returnData.list, listIndex, ruleForm)
                }
                if (allIndex !== -1) {
                    this.$set(this.allData, allIndex, ruleForm)
                }
                if (filterIndex !== -1) {
                    this.$set(this.filteredData, filterIndex, ruleForm)
                }
                this.$nextTick(() => {
                    if (this.paginatedData[this.selectedDataIndex]) {
                        this.$refs.singleTable.setCurrentRow(this.paginatedData[this.selectedDataIndex]);
                    }
                })
            } else {
                this.$message.success(resData.message)
            }
        },
        // 获取数据列表
        async getPageInfo() {
            var pathId = parent.getMenuInfo(this.$route.path);
            let responseData = await this.$http.getJur({
                ids: [pathId.jurId],
            });
            if (responseData.status == 200) {
                this.pageShowData = responseData.result;
                this.formDataList = this.pageShowData.jurFormVoList
                this.serchlist = this.pageShowData.jurHead.jurconfigform
                this.returnData.name = this.formDataList[1].jurconfigform
                this.fromNamelist = this.pageShowData.jurTableVo.jurconfigtable
                this.getButtonList()
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        // 获取按钮权限
        async getButtonList() {
            this.buttonList = await this.$common.getActionButton()
            
        },
// 点击穿透字段 传参单号
        toDetail(orderId) {
            if (orderId) {
                // 设置为true 打开穿透组件首页    
                var isPenetrate = true
                // 设置缓存 存入点击单号
                this.resetSetItem('penetrateOrderId', orderId);
                // 与父级跨域通信 传递isPenetrate参数
                window.parent.postMessage({ //向窗口发送MessageEvent消息
                    cmd: 'returnFormJson',
                    params: {
                        isPenetrate
                    } //参数
                }, '*');
            }
        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        // this.returnData.name = stockLnventory.stockLnventoryReject
        this.getPageInfo()
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        window.addEventListener("resize", this.getHeight)
        this.$nextTick(() => {
            this.getHeight()
            // 设置表格可以获得焦点，以便接收键盘事件
            if (this.$refs.singleTable && this.$refs.singleTable.$el) {
                this.$refs.singleTable.$el.focus();
            }
        })
    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_content_tag {
    margin-right: 1rem;
}

.el-tabs--border-card_new {
    height: 85vh;
    overflow-y: scroll;
}

.page_content_center {
    position: relative;
}

.table {
    display: inline-block;
}

/* 分页组件样式 */
.pagination-wrapper {
    text-align: right;
    padding-right: 20px;
}

.pagination-wrapper .el-pagination {
    display: inline-block;
}

.right {
    position: absolute;
    right: 0;
    top: 0;
    width: 300px !important;
    /* background-color: #fff; */
    z-index: 99;
}

.right ::v-deep tr {
    background-color: #fff;
}

.dete {
    width: 162px;
}
</style>